/** 1 knot = 1.852 km/h */
const KNOTS_TO_KMH = 1.852;

/**
 * Format speed for display. When convertKnotsToKmph is true, treats value as knots and converts to km/h.
 * @param speed - Raw speed value (in knots if convertKnotsToKmph is true, else as-is in km/h). Coerced to number if string.
 * @param convertKnotsToKmph - If true, multiply by 1.852 to get km/h; if false, display as-is with " km/h"
 * @returns e.g. "3.70 km/h" or "0.00 km/h" when speed is null/undefined/invalid (show zero instead of an em dash)
 */
export function formatSpeedDisplay(
  speed: number | string | null | undefined,
  convertKnotsToKmph: boolean
): string {
  if (speed == null || speed === '') {
    return '0.00 km/h';
  }
  const numSpeed = typeof speed === 'string' ? parseFloat(speed) : Number(speed);
  if (isNaN(numSpeed)) {
    return '0.00 km/h';
  }
  const value = convertKnotsToKmph ? numSpeed * KNOTS_TO_KMH : numSpeed;
  return `${Number(value).toFixed(2)} km/h`;
}
